import Ner from "./Ner";

export default Ner;
